// TonicPrizes.jsx
import React, { useCallback, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import MainLayout from '../../layouts/MainLayout';
import '../wallet/MyWallet.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal, faRankingStar } from '@fortawesome/free-solid-svg-icons';

const TonicPrizes = () => {
  const authState = useSelector(state => state.authReducer);
  const userId = authState.user._id
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();

  const [prizesList, setPrizesList] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  
  //Prizes
  const fetchList = useCallback(() => {
    const config = {
      url: "/tonicprizes/list",
      method: "post",
      headers: { Authorization: authState.token }
    };

    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("Response:", response);
        if (response && Array.isArray(response.prizesList)) {
          setPrizesList(response.prizesList);
        } else {
          console.error("Data not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchList();
  }, [authState.isLoggedIn, fetchList]);

  const sortedPrizesList = [...prizesList].sort((a, b) => b.rank - a.rank);

  const handleListView = (_id) => {
    setSelectedId(prevId => (prevId === _id ? null : _id));
  };

  const formatDateTime = (date) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className='bg-black text-white [&_p]:text-white'>
      <div>
        <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Think5Whys Tonic Contest Prizes </h3>
      </div>
      <div className="mx-auto max-w-[760px]">
        <div className="list-container p-4 mt-4">
          {loading ? (
            <Loader />
          ) : (
            <div className='w-full'>
              <div className="flex flex-row justify-between items-center ">
                <div>
                <h3 className='text-2xl mt-1 mx-2 text-white'><FontAwesomeIcon icon={faMedal} className="text-red-500 text-4xl mr-2" />Contest Prizes</h3>
                </div>
                <div className='flex flex-row'>
                  <button
                    className='bg-purple-700'
                    onClick={handleCancel}
                    style={{ maxWidth: '150px' }}
                  >
                    Back
                  </button>
                </div>
              </div>
              <div>
                {prizesList && prizesList.length === 0 ? (
                  <div className="flex items-center justify-center text-yellow-300 text-lg h-64">
                    No records found!
                  </div>
                ) : (
                  <>
                    {sortedPrizesList.map((listItem, index) => (
                      <div key={listItem._id} className="bg-gray-600 my-4 p-4 text-white rounded-lg shadow-lg">
                        <div className="flex justify-between items-center mb-2">
                          <span className="font-medium text-white">
                            {index + 1}. {listItem.tonicName}<br/>
                          </span>
                          <Tooltip text="View details" position="top">
                            <span className="text-white cursor-pointer" onClick={() => handleListView(listItem._id)}>
                              <i className="fa-solid fa-eye"></i>
                            </span>
                          </Tooltip>
                        </div>
                        {selectedId === listItem._id && (
                          <div className="bg-gray-600 p-4 text-black rounded-lg shadow-inner">
                            <p><strong>Current Contest Date:</strong> {formatDateTime(listItem.fromDate)}{' to '}{formatDateTime(listItem.toDate)}</p>
                            <p><strong>Details:</strong> {listItem.prizeDetails}</p>
                            <p><strong>Remarks:</strong> {listItem.prizeRemarks}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TonicPrizes;




